import CustomComponent from '../CustomComponent';

class EmailConsentBox extends CustomComponent {
    static key = 'lta-email-consent-box';

    static get observedAttributes() {
        return ['consent-text'];
    }

	constructor() {
		super();
		
		this.state = {
            consentText: 'Yes, I would like to receive emails from the LTA and its group companies including exclusive benefits, upcoming events, relevant tennis programmes and courses for all ages and abilities.',
		};
		
	}

    onLoad() {
        
    }

    onUnload() {
        
    }

    afterRender() {
    
    }

	render(children) {
        const consentText = this.props.consentText || this.state.consentText;
        return `
            <div class="lta-email-consent-box">
                ${children}
                <div class="lta-email-consent-box__form-check lta-form-check lta-form-checkbox u-mb-3">
                    <input class="lta-form-check-input" type="checkbox" name="marketingConsent" id="marketingCheck" value="Yes">  
                    <label class="lta-form-check-label u-text-grey-lta" for="marketingCheck">${consentText}</label>
                </div>
            </div>
        `;
    }
}

export default EmailConsentBox;